export default "__VITE_ASSET__CLHBySGI__"